export const SearchField = ({placeholder, className, onSearch}: {placeholder?: string; className?: string; onSearch: (searchText: string) => void}) => {
    return <input type="search" placeholder={placeholder} className={`p-2 text-black rounded-md w-72 ${className}`} onChange={(e) => onSearch(e.target.value)} />
}